import { Box, CircularProgress, Typography } from "@mui/material";
import styles from "./styles";

const PageLoader = ({ isLoading, error, errorMessage = "Failed to load", children }) => {
  if (isLoading) {
    return (
      <Box sx={styles.centerBoxSx}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={styles.centerBoxSx}>
        <Typography color="error">{errorMessage}</Typography>
      </Box>
    );
  }

  return children;
};

export default PageLoader;
